<template>
    <div class="bento-container course-resource-page">
        <!-- Main Content Area -->
        <div class="main-section">
            <!-- Bento Grid Layout -->
            <div class="bento-grid">
                <!-- AI Assistant Card -->
                <div class="bento-card ai-assistant-card">
                    <div class="ai-header-section">
                        <div class="breadcrumb-nav">
                            <el-breadcrumb separator="/">
                                <el-breadcrumb-item :to="{ path: '/' }"></el-breadcrumb-item>
                                <el-breadcrumb-item v-for="(item, index) in currentBreadCrumb" :key="index">
                                    {{ item }}
                                </el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                        <div class="header-controls">
                            <!-- Category Type Buttons -->
                            <div class="category-type-buttons">
                                <div class="type-btn" :class="{ active: activeAccType === null }"
                                    @click="handleAccTypeChange(null)">
                                    全部
                                </div>
                                <div class="type-btn" :class="{ active: activeAccType === 1 }"
                                    @click="handleAccTypeChange(1)">
                                    精选课程
                                </div>
                                <div class="type-btn" :class="{ active: activeAccType === 2 }"
                                    @click="handleAccTypeChange(2)">
                                    移动集采
                                </div>
                                <div class="type-btn" :class="{ active: activeAccType === 3 }"
                                    @click="handleAccTypeChange(3)">
                                    行业课程
                                </div>
                            </div>
                            <div style="display:flex;align-items:center">
                                <div class="sidebar-search" style="margin-right: 10px;">
                                    <div class="search-input-wrapper">
                                        <el-input v-model="keywordSearch" placeholder="搜索课程关键词" size="small" clearable
                                            class="sidebar-input" @keydown.enter.native="handleKeywordSearch"
                                            @clear="handleKeywordSearch">
                                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                        </el-input>
                                    </div>
                                    <div class="ai-toggle-btn" @click="handleKeywordSearch">
                                        <i class="el-icon-search"></i>
                                        <span>搜索</span>
                                    </div>
                                </div>
                                <!-- <div class="ai-reset-btn" @click="resetAiSelection">
                                <i class="el-icon-refresh-right"></i>
                                <span>重置</span>
                            </div> -->
                                <div style="margin-left:0px;" class="ai-toggle-btn" @click="toggleAiHelper">
                                    <i class="el-icon-microphone"></i>
                                    <span>AI 智能选课</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- AI Helper Panel -->
                    <transition name="slide-fade">
                        <div v-if="isAiHelperOpen" class="ai-panel">
                            <div class="ai-panel-header">
                                <div class="ai-panel-title">
                                    <span class="ai-avatar">
                                        <i class="el-icon-chat-dot-round"></i>
                                    </span>
                                    <span>智能选课助手</span>
                                </div>
                                <div class="ai-panel-close" @click="toggleAiHelper">
                                    <i class="el-icon-close"></i>
                                </div>
                            </div>
                            <div class="ai-panel-body">
                                <div class="ai-welcome">
                                    <div class="ai-avatar-large">
                                        <i class="el-icon-user-solid"></i>
                                    </div>
                                    <div class="ai-welcome-text">
                                        <p class="ai-greeting">Hi，我是您的 AI 选课助手</p>
                                        <p class="ai-hint">描述您的培训需求，我来为您匹配最适合的课程</p>
                                    </div>
                                </div>
                                <div class="ai-input-section" style="display:flex;align-items: center;">
                                    <el-input v-model="aiInputText" type="textarea"
                                        autosizeplaceholder="例如：给中层管理人员进行团队建设培训" class="ai-input-field"
                                        @keyup.enter.native="sendAiRequest" style="max-width: 90%;">
                                    </el-input>
                                    <el-button class="ai-send-btn" @click="sendAiRequest" style="margin-left: 10px;">
                                        <i class="el-icon-s-promotion"></i>
                                        智能匹配
                                    </el-button>
                                </div>
                                <!-- AI Loading - 跳一跳风格 -->
                                <div v-if="isLoading" class="ai-loading-section">
                                    <div class="jump-loading">
                                        <div class="jump-track">
                                            <div class="jump-character-wrapper">
                                                <div class="jump-character">
                                                    <div class="jump-body">
                                                        <div class="jump-eyes">
                                                            <div class="eye left"></div>
                                                            <div class="eye right"></div>
                                                        </div>
                                                        <div class="jump-mouth"></div>
                                                    </div>
                                                    <div class="jump-shadow"></div>
                                                </div>
                                            </div>
                                            <div class="jump-platforms">
                                                <div class="platform active"></div>
                                                <div class="platform"></div>
                                                <div class="platform"></div>
                                                <div class="platform"></div>
                                                <div class="platform"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="loading-text">正在为您智能分析课程需求...</p>
                                </div>
                                <!-- AI Analysis Result -->
                                <div v-else-if="aiAnalysisData" class="ai-result-section">
                                    <div class="ai-result-header">
                                        <div class="result-status">
                                            <i class="el-icon-circle-check"></i>
                                            <span>分析完成</span>
                                        </div>
                                        <div class="ai-model-tag">
                                            <i class="el-icon-cpu"></i>
                                            DeepSeek AI
                                        </div>
                                    </div>
                                    <div class="ai-result-content">
                                        <div class="match-summary">
                                            <p class="match-title">匹配分析</p>
                                            <p class="match-description">{{ aiAnalysisData.matchReason }}</p>
                                        </div>
                                        <div v-for="(reason, index) in aiAnalysisData.courseReasons" :key="index"
                                            class="course-match-reason">
                                            <i class="el-icon-check"></i>
                                            {{ reason }}
                                        </div>
                                    </div>
                                    <div class="ai-keywords-section">
                                        <p class="keywords-label">关键词标签</p>
                                        <div class="keywords-list">
                                            <el-tag v-for="(keyword, idx) in aiAnalysisData.keywords" :key="idx"
                                                size="small" class="keyword-item">
                                                {{ keyword }}
                                            </el-tag>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>

            <div class="bento-grid" style="position: relative;" v-if="isCategoryContainerVisible">
                <!-- Category Container with Level1, Level2, Level3 - Video Library Style -->
                <div class="bento-card category-card">
                    <div class="category-header">
                        <span class="category-title-text">
                            <i class="el-icon-price-tag"></i>
                            课程分类
                        </span>
                        <div class="category-fold-btn" @click="toggleCategoryFold">
                            <i :class="isCategoryFolded ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
                            <span>{{ isCategoryFolded ? '展开' : '折叠' }}</span>
                        </div>
                    </div>
                    <div class="category-content video-category-style" v-show="!isCategoryFolded">
                        <!-- Level 1 Categories Row -->
                        <div class="category-row" v-if="courseData.level1Categories.length > 0">
                            <span class="row-label">一级分类:</span>
                            <div class="category-tag-list">
                                <div class="level3-tag" :class="{ 'active': activeLevel1Id === null }"
                                    @click="handleLevel1Change(null)">
                                    全部
                                </div>
                                <div v-for="category in courseData.level1Categories" :key="category.accId"
                                    class="level3-tag" :class="{ 'active': activeLevel1Id === category.accId }"
                                    @click="handleLevel1Change(category.accId)">
                                    {{ category.accName }}
                                </div>
                            </div>
                        </div>
                        <!-- Level 2 Categories Row -->
                        <div class="category-row" v-if="courseData.level2Categories.length > 0">
                            <span class="row-label">二级分类:</span>
                            <div class="category-tag-list">
                                <div class="level3-tag" :class="{ 'active': activeLevel2Id === null }"
                                    @click="handleLevel2Change(null)">
                                    全部
                                </div>
                                <div v-for="category in courseData.level2Categories" :key="category.accId"
                                    class="level3-tag" :class="{ 'active': activeLevel2Id === category.accId }"
                                    @click="handleLevel2Change(category.accId)">
                                    {{ category.accName }}
                                </div>
                            </div>
                        </div>
                        <!-- Level 3 Categories Row -->
                        <div class="category-row" v-if="courseData.level3Categories.length > 0">
                            <span class="row-label">三级分类:</span>
                            <div class="category-tag-list" :class="{ 'expanded': isExpand }">
                                <div class="level3-tag"
                                    :class="{ 'active': activeLevel3Id === activeLv3Defult || !activeLevel3Id }"
                                    @click="handleLevel3Change(null)">
                                    全部
                                </div>
                                <div v-for="category in courseData.level3Categories" :key="category.accId"
                                    class="level3-tag" :class="{ 'active': activeLevel3Id === category.accId }"
                                    @click="handleLevel3Change(category.accId)">
                                    {{ category.accName }}
                                </div>
                            </div>
                        </div>
                        <div class="expand-toggle" @click="toggleExpand" v-if="courseData.level3Categories.length > 15">
                            {{ isExpand ? '收起' : '展开全部' }}
                            <i class="el-icon-arrow-down" :class="{ 'rotated': isExpand }"></i>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Course Cards Grid -->
            <div class="bento-grid" style="position: relative;" ref="coursesGrid">
                <div class="bento-card courses-card" :class="'courses-card-type-' + activeAccType"
                    :style="{ height: coursesCardHeight + 'px' }">
                    <div class="courses-header">
                        <span class="courses-title-text">
                            <i class="el-icon-reading"></i>
                            推荐课程
                        </span>
                        <div style="display: flex;align-items: center;">
                            <span class="courses-count" style="margin-right: 10px;">
                                点击量 <i class="el-icon-thumb"></i>: <span style="color: #409EFF; cursor: pointer;"
                                    @click="handleSort(1, 2)">{{
                                        [1, 3, 5].includes(pagination.courseNumClickSort) ? '升序' : '降序' }}
                                    <i class="el-icon-sort"
                                        :style="{ transform: [2, 4, 6].includes(pagination.courseNumClickSort) ? 'rotate(180deg)' : '' }"></i></span>
                            </span>
                            <span class="courses-count" style="margin-right: 10px;">
                                下载量 <i class="el-icon-download"></i>: <span style="color: #409EFF; cursor: pointer;"
                                    @click="handleSort(3, 4)">{{
                                        [1, 3, 5].includes(pagination.courseNumClickSort) ? '升序' : '降序' }}
                                    <i class="el-icon-sort"
                                        :style="{ transform: [2, 4, 6].includes(pagination.courseNumClickSort) ? 'rotate(180deg)' : '' }"></i></span>
                            </span>
                            <span class="courses-count" style="margin-right: 10px;">
                                更新时间 <i class="el-icon-time"></i>: <span style="color: #409EFF; cursor: pointer;"
                                    @click="handleSort(5, 6)">{{
                                        [1, 3, 5].includes(pagination.courseNumClickSort) ? '升序' : '降序' }}
                                    <i class="el-icon-sort"
                                        :style="{ transform: [2, 4, 6].includes(pagination.courseNumClickSort) ? 'rotate(180deg)' : '' }"></i></span>
                            </span>
                            <span class="courses-count" style="margin-left: 10px;">
                                <i class="el-icon-document"></i>
                                共 {{ pagination.total }} 个课程
                            </span>
                        </div>

                    </div>
                    <div class="courses-content">
                        <div class="courses-grid" v-if="courseData.courses.length > 0">
                            <div class="course-card" :class="'course-card-type-' + course.accType"
                                v-for="course in courseData.courses" :key="course.courseId"
                                @mouseenter="hoverCourseId = course.courseId" @mouseleave="hoverCourseId = null">
                                <div class="course-card-header" style="
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                " :class="{ 'hover': hoverCourseId === course.courseId }">
                                    <!-- NEW 和 HOT 标签 -->
                                    <div class="course-tags">
                                        <span v-if="course.courseNew == 2" class="tag-new">NEW</span>
                                        <span v-if="course.courseHot == 2" class="tag-hot">HOT</span>
                                    </div>
                                    <h3 class="course-title">{{ course.courseTitle }}</h3>
                                    <div class="course-meta">
                                        <span class="meta-item">
                                            <i class="el-icon-thumb"></i>
                                            {{ course.courseNumClick || '0' }}
                                        </span>
                                        <span class="meta-item">
                                            <i class="el-icon-download"></i>
                                            {{ course.courseNumDownload || '0' }}
                                        </span>
                                        <span class="meta-item">
                                            <i class="el-icon-timer"></i>
                                            {{ course.courseStyle || '0' }}
                                        </span>
                                    </div>
                                </div>
                                <div class="course-card-body">
                                    <div class="target-audience">
                                        <span class="label">适用人群</span>
                                        <span class="value">{{ course.acsuName || '待定' }}</span>
                                    </div>
                                    <div class="course-intro boxSizeHidden">
                                        {{ course.courseIntroduce || '暂无简介' }}
                                    </div>
                                </div>
                                <div class="course-card-footer">
                                    <div class="footer-left">
                                        <i class="el-icon-calendar"></i>
                                        {{ course.updatetime }}
                                    </div>
                                    <div class="footer-right">
                                        <el-button size="mini" class="action-btn" @click="viewCourse(course)">
                                            <i class="el-icon-view"></i>
                                            查看
                                        </el-button>
                                        <!-- <el-button size="mini" class="action-btn primary" @click="selectCourse(course)">
                                            <i class="el-icon-check"></i>
                                            选用
                                        </el-button> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="empty-courses">
                            <div class="empty-icon">
                                <i class="el-icon-search"></i>
                            </div>
                            <p class="empty-text">暂无相关课程</p>
                            <p class="empty-hint">请尝试其他分类或使用AI智能选课</p>
                        </div>
                    </div>

                    <!-- Pagination -->
                    <div style="
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            bottom: 5px;
            left: 0;
            background-color: white;
          ">
                        <div class="pagination-wrapper" v-if="!isAiSearch && pagination.total > pagination.pageSize">
                            <el-pagination background layout="prev, pager, next" :total="pagination.total"
                                :page-size="pagination.pageSize" :current-page.sync="pagination.currentPage"
                                @current-change="handlePageChange">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 课程暂存区浮窗按钮 -->
        <div class="storage-float-btn" @click="isStorageVisible = true">
            <i class="el-icon-collection"></i>
            <span class="storage-count"
                v-if="temporaryStorage.length + (aiOptimizeStorageCount > 0 ? aiOptimizeStorageCount : aiOptimizeStorage.length) > 0">{{
                    temporaryStorage.length
                    + (aiOptimizeStorageCount > 0 ? aiOptimizeStorageCount : aiOptimizeStorage.length) }}</span>
        </div>

        <!-- 暂存区抽屉 -->
        <el-drawer title="我的暂存区" :visible.sync="isStorageVisible" direction="rtl" size="480px">
            <div class="storage-drawer-content">
                <!-- Tab切换 -->
                <div class="storage-tab-header">
                    <div class="storage-tab-nav">
                        <div class="storage-tab-item" :class="{ active: storageTabActive === 'course' }"
                            @click="tabValueChange('course')">
                            <i class="el-icon-collection"></i>
                            <span>课程暂存区</span>
                            <span class="storage-tab-badge">{{ temporaryStorage.length }}</span>
                        </div>
                        <div class="storage-tab-item" :class="{ active: storageTabActive === 'ai' }"
                            @click=" tabValueChange('ai')">
                            <i class="el-icon-magic-stick"></i>
                            <span>AI优化暂存区</span>
                            <span class="storage-tab-badge ai-badge">{{ aiOptimizeStorageCount > 0 ?
                                aiOptimizeStorageCount :
                                aiOptimizeStorage.length }}</span>
                        </div>
                    </div>
                </div>
                <el-tabs v-model="storageTabActive" class="storage-tabs" :before-leave="handleTabChange">
                    <el-tab-pane name="course">
                        <div class="storage-list" v-if="temporaryStorage.length > 0">
                            <div class="storage-item" v-for="course in temporaryStorage" :key="course.acoId">
                                <el-checkbox v-model="temporaryStorageSelected" :label="course.acoId"
                                    class="storage-checkbox">
                                    <div class="storage-item-info">
                                        <div class="storage-item-content">
                                            <h4 class="storage-item-title">{{ course.courseTitle }}</h4>
                                            <h5 class="storage-item-subtitle">{{ course.teacherNames }}</h5>
                                            <div class="storage-item-meta">
                                                <span><i class="el-icon-time"></i>{{ course.courseStyle || '-' }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </el-checkbox>
                                <div class="storage-item-actions">
                                    <el-button size="mini" type="primary" plain circle icon="el-icon-view"
                                        @click="viewCourseMine(course)"></el-button>
                                    <el-button size="mini" type="danger" plain circle icon="el-icon-close"
                                        @click="removeFromStorage(course)"></el-button>
                                </div>
                            </div>
                        </div>
                        <div class="storage-empty" v-else>
                            <div class="empty-icon">
                                <i class="el-icon-folder-opened"></i>
                            </div>
                            <p class="empty-text">课程暂存区为空</p>
                            <p class="empty-hint">点击课程卡片上的"选用"按钮添加课程</p>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="ai">
                        <div class="storage-list" v-if="aiOptimizeStorage.length > 0">
                            <div class="storage-item" v-for="item in aiOptimizeStorage" :key="item.acscId">
                                <el-checkbox v-model="aiOptimizeStorageSelected" :label="item.acscId"
                                    class="storage-checkbox">
                                    <div class="storage-item-info">
                                        <div class="storage-item-content">
                                            <h4 class="storage-item-title">{{ JSON.parse(item.acscTextTwo).courseTitle
                                                || '' }}
                                            </h4>
                                            <h5 class="storage-item-subtitle">{{ item.updatetime }}</h5>
                                            <div class="storage-item-meta">
                                                <el-tag size="mini" type="success">AI优化</el-tag>
                                            </div>
                                        </div>
                                    </div>
                                </el-checkbox>
                                <div class="storage-item-actions">
                                    <el-button size="mini" type="primary" plain circle icon="el-icon-view"
                                        @click="viewAiOptimize(item)"></el-button>
                                    <el-button size="mini" type="danger" plain circle icon="el-icon-close"
                                        @click="removeAiOptimize(item)"></el-button>
                                </div>
                            </div>
                        </div>
                        <div class="storage-empty" v-else>
                            <div class="empty-icon">
                                <i class="el-icon-magic-stick"></i>
                            </div>
                            <p class="empty-text">AI优化暂存区为空</p>
                            <p class="empty-hint">通过AI优化功能优化的课程将显示在此处</p>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <!-- 底部操作栏 -->
                <div class="storage-footer" v-if="getCurrentStorageLength() > 0">
                    <div class="storage-footer-info">
                        <el-checkbox :value="isAllSelected" @input="handleToggleSelectAll" class="select-all-checkbox">
                            全选
                        </el-checkbox>
                        <span class="selected-count">已选择 <strong>{{ getSelectedCount() }}</strong> 项</span>
                    </div>
                    <div class="storage-footer-actions">
                        <el-button size="small" type="primary" :disabled="getSelectedCount() === 0"
                            @click="exportStorageWord(storageTabActive)">
                            <i class="el-icon-document"></i> Word
                        </el-button>
                        <el-button size="small" type="success" :disabled="getSelectedCount() === 0"
                            @click="exportStorageExcel(storageTabActive)">
                            <i class="el-icon-tickets"></i> Excel
                        </el-button>
                    </div>
                </div>
            </div>
        </el-drawer>

        <!-- 课程详情弹框（资源库模式 optionsId=2） -->
        <course-detail-dialog ref="courseDetailDialog" :dialog-visible.sync="isDetailVisible"
            :course-id="currentCourseId" :options-id="2" dialog-title="课程详情" :footer-buttons="detailFooterButtons"
            @download-doc="handleDownloadDoc" @getDetailData="getDetailData" @ai-optimize="handleAiOptimize"
            :external-detail-data="myDetailData" />
        <!-- AI优化弹窗 -->
        <ai-optimize-dialog ref="aiOptimizeDialog" :dialog-visible.sync="isAiOptimizeVisible" :aco-id="currentAcoId"
            :course-data="currentCourseData" :version-index="currentVersionIndex" dialog-title="大纲优化"
            @save="handleAiSaveOptimized" :footer-buttons="AidetailFooterButtons"
            :AiDiaLogDetailType="AiDiaLogDetailType" :AiShowDetailData="AiShowDetailData"
            :AiDiaLogShow="AiDiaLogShow" />
        <!-- 暂存区课程详情弹框 -->
        <aj-form-detail :dialog-visible.sync="isStorageDetailVisible" :sections="storageDetailSections"
            :detail-data="storageDetailData" dialog-title="课程详情" dialog-width="800px" :show-footer="false" />
    </div>
</template>

<script>
import {
    getAjCourseClassList, getAjCourseOutlineDetails,
    getAjCourseList,
    getAjCourseClassListChild,
    getAjCourseListAi,
    //加工区
    updateAjCourseSelectedAdd,
    getAjCourseSelectedMine, exportFile, getAjCourseOutlineDetailsByIds,
    updateAjCourseSelectedRemove, updateAjCourseDownloadNumAddOne,
    //AI优化
    updateAjCourseSelectedCustomizeAdd, getAjCourseSelectedCustomizeMine, updateAjCourseSelectedCustomizeRemove, updateAjCourseSelectedCustomizeText, exportAjCourseSelectedCustomize,

} from "../../api/api";
import qs from 'qs';
import {
    exportCourseWord, selectTemplateByHighlights, loadLocalTemplateLibrary, getPreloadedTemplateLibrary, downloadBatchWord, downloadWord, generateCourseWord, parseBenefits
} from "../../utils/wordExport";
import CourseDetailDialog from '@/components/page_components/CourseDetailDialog.vue';
import AiOptimizeDialog from '@/components/page_components/AiOptimizeDialog.vue';
import AjFormDetail from '@/components/ajForm/ajFormDetail.vue';
import "./courseResourceManagement.css";

export default {
    name: "CourseManagement",
    components: {
        CourseDetailDialog,
        AiOptimizeDialog,
        AjFormDetail
    },
    data() {
        return {
            AiDiaLogShow: false,
            AiShowDetailData: {},//直接展示对比的原版数据
            AiDiaLogDetailType: 1,//1-暂存区Ai优化，2-Ai优化对比
            aiOptimizeStorageCount: 0,//AI优化暂存计数
            DiaLogDetailType: 1,//1-课程详情，2-暂存区讲师版本详情
            myDetailData: {},//暂存区详情数据
            isExportingWord: false,//防止重复导出Word
            aiSend: "",
            activeLv3Defult: null,
            theMenuVale: "all",
            theMenuOpen: [],
            hoverActionId: null,
            hoverCourseId: null,
            activeLevel3Id: null,
            isExpand: false,
            isCategoryFolded: false, // 分类区域折叠状态
            // 分类类型相关
            activeAccType: null, // 1-精选课程 2-移动集采 3-行业课程
            isCategoryContainerVisible: false, // 分类容器是否显示
            activeLevel1Id: null, // 当前选中的一级分类ID
            activeLevel2Id: null, // 当前选中的二级分类ID
            currentCategoryLevel: 1, // 当前显示的分类层级 (1-一级 2-二级 3-三级)
            coursesCardHeight: 0, // 课程卡片容器高度
            // AI助手相关状态
            isAiHelperOpen: false,
            aiInputText: "",
            // 关键词搜索
            keywordSearch: "",
            // 面包屑数据
            currentBreadCrumb: [],
            // AI分析数据
            aiAnalysisData: null,
            // 是否是AI选课结果（不分页）
            isAiSearch: false,
            // 加载状态
            isLoading: false,
            // 分页数据
            pagination: {
                courseNumClickSort: 0,
                currentPage: 1,
                pageSize: 12,
                total: 0,
            },
            courseData: {
                level1Categories: [],
                level2Categories: [],
                level3Categories: [],
                courses: [],
            },
            // 暂存区相关
            isStorageVisible: false,
            storageTabActive: 'course', // 当前tab: course-课程暂存区, ai- AI优化暂存区
            // 课程暂存区
            temporaryStorage: [],
            temporaryStorageSelected: [], // 选中的课程id
            // AI优化暂存区
            aiOptimizeStorage: [],
            aiOptimizeStorageSelected: [], // 选中的AI优化id
            // 课程详情弹框
            isDetailVisible: false,
            currentCourseId: null,
            // AI优化弹框相关
            isAiOptimizeVisible: false,
            currentAcoId: null,
            currentCourseData: null,
            currentVersionIndex: 0,
            // 当前详情弹框的版本是否已选用
            currentVersionSelected: false,
            // 暂存区课程详情弹框
            isStorageDetailVisible: false,
            storageDetailData: {},
            storageDetailSections: [],
        };
    },
    created() {
        // 预加载模板库
        this.loadTemplates();
        // 页面初始化时加载所有课程
        this.getCoursList(null);
        // 加载分类数据供后面使用
        getAjCourseClassList({ accParentId: 0 }).then((res) => {
            this.courseData.level1Categories = res.data;
            this.courseData.level1Categories.forEach((item) => {
                item.level2 = [];
                item.loading = false;
                item.loaded = false;
            });
        });
        this.getTemporary()
    },
    mounted() {
        // 计算课程卡片容器高度
        this.calculateCoursesCardHeight();
        // 监听窗口大小变化
        window.addEventListener('resize', this.calculateCoursesCardHeight);
    },
    beforeDestroy() {
        // 移除窗口大小监听
        window.removeEventListener('resize', this.calculateCoursesCardHeight);
    },
    watch: {
        // 监听分类容器显示状态变化，重新计算高度
        isCategoryContainerVisible() {
            this.$nextTick(() => {
                this.calculateCoursesCardHeight();
            });
        },
        // 监听二级分类数据变化，重新计算高度
        'courseData.level2Categories': {
            handler() {
                this.$nextTick(() => {
                    this.calculateCoursesCardHeight();
                });
            },
            deep: true
        },
        // 监听三级分类数据变化，重新计算高度
        'courseData.level3Categories': {
            handler() {
                this.$nextTick(() => {
                    this.calculateCoursesCardHeight();
                });
            },
            deep: true
        }
    },
    computed: {
        // 判断用户是否有AI优化权限（管理员或部门ID为7）
        canUseAiOptimize() {
            const userInfoStr = localStorage.getItem('zhikeTong_userInfo');
            if (!userInfoStr) return false;
            try {
                const userInfo = JSON.parse(userInfoStr);
                // auPost=1 表示管理员，adId=7 表示部门ID为7
                return userInfo.auPost === 1 || userInfo.adId === 7;
            } catch (e) {
                return false;
            }
        },
        // 当前分类层级的名称
        currentCategoryLevelName() {
            if (this.currentCategoryLevel === 1) return '一级分类';
            if (this.currentCategoryLevel === 2) return '二级分类';
            if (this.currentCategoryLevel === 3) return '三级分类';
            return '三级分类';
        },
        // 当前分类数量
        currentCategoryCount() {
            if (this.currentCategoryLevel === 1) return this.courseData.level1Categories.length;
            if (this.currentCategoryLevel === 2) return this.courseData.level2Categories.length;
            if (this.currentCategoryLevel === 3) return this.courseData.level3Categories.length;
            return 0;
        },
        // 是否全选
        isAllSelected() {
            if (this.storageTabActive === 'course') {
                return this.temporaryStorage.length > 0 && this.temporaryStorageSelected.length === this.temporaryStorage.length;
            } else {
                return this.aiOptimizeStorage.length > 0 && this.aiOptimizeStorageSelected.length === this.aiOptimizeStorage.length;
            }
        },
        AidetailFooterButtons() {
            const dialog = this.$refs.aiOptimizeDialog;
            if (this.AiDiaLogDetailType === 1) {
                return [
                    {
                        text: '导出word',
                        type: 'success',
                        icon: 'el-icon-download',
                        onClick: function () {
                            if (dialog && dialog.handleSaveOptimized) {
                                dialog.handleSaveOptimized();
                            }
                        },
                        class: 'btn-download'
                    },
                    {
                        text: '选用',
                        type: 'warning',
                        icon: 'el-icon-check',
                        onClick: this.handleAiSelectCourse,
                        class: 'btn-select btn-selected'
                    },
                    { text: '关闭', plain: true }
                ];
            } else {
                return [
                    {
                        text: '导出word',
                        type: 'success',
                        icon: 'el-icon-download',
                        onClick: function () {
                            if (dialog && dialog.handleSaveOptimized) {
                                dialog.handleSaveOptimized();
                            }
                        },
                        class: 'btn-download'
                    },
                    {
                        text: '编辑',
                        type: 'warning',
                        icon: 'el-icon-check',
                        onClick: this.handleAiEditTemplate,
                        class: 'btn-select btn-selected'
                    },
                    { text: '关闭', plain: true }
                ];
            }
        },

        // 课程详情弹框底部按钮
        detailFooterButtons() {
            const dialog = this.$refs.courseDetailDialog;
            if (this.DiaLogDetailType === 1) {
                // 类型1：下载Word、选用、关闭
                return [
                    {
                        text: '下载Word',
                        type: 'success',
                        icon: 'el-icon-download',
                        onClick: function () {
                            if (dialog && dialog.handleDownload) {
                                dialog.handleDownload();
                            }
                        },
                        class: 'btn-download'
                    },
                    {
                        text: '选用',
                        type: 'warning',
                        icon: 'el-icon-check',
                        onClick: this.handleSelectCourse,
                        class: this.currentVersionSelected ? 'btn-select btn-selected' : 'btn-select'
                    },
                    {
                        text: '课程评论',
                        type: 'warning',
                        icon: 'el-icon-chat-line-round',
                        onClick: () => {
                            const dialog = this.$refs.courseDetailDialog;
                            if (dialog && dialog.handleOpenComment) {
                                dialog.handleOpenComment();
                            }
                        }
                    },
                    { text: '关闭', plain: true }
                ];
            } else {
                // 类型2及其他：下载Word、AI优化、生成大纲逻辑图、关闭
                const buttons = [
                    {
                        text: '下载Word',
                        type: 'success',
                        icon: 'el-icon-download',
                        onClick: function () {
                            if (dialog && dialog.handleDownload) {
                                dialog.handleDownload();
                            }
                        },
                        class: 'btn-download'
                    },
                    // AI优化按钮 - 只有管理员(auPost=1)或部门ID为7的用户可见
                    this.canUseAiOptimize ? {
                        text: 'AI优化',
                        type: 'primary',
                        icon: 'el-icon-magic-stick',
                        onClick: this.handleAiOptimize,
                        class: 'btn-ai'
                    } : null,
                    {
                        text: '生成大纲逻辑图',
                        type: 'primary',
                        icon: 'el-icon-connection',
                        onClick: this.handleGenerateDiagram
                    },
                    {
                        text: '课程评论',
                        type: 'warning',
                        icon: 'el-icon-chat-line-round',
                        onClick: () => {
                            const dialog = this.$refs.courseDetailDialog;
                            if (dialog && dialog.handleOpenComment) {
                                dialog.handleOpenComment();
                            }
                        }
                    },
                    { text: '关闭', plain: true }
                ];
                // 过滤掉 null 值（AI优化按钮权限过滤）
                return buttons.filter(btn => btn !== null);
            }
        }
    },
    methods: {
        // 计算课程卡片容器高度
        calculateCoursesCardHeight() {
            this.$nextTick(() => {
                const windowHeight = window.innerHeight;
                const coursesGrid = this.$refs.coursesGrid;
                if (coursesGrid) {
                    const gridRect = coursesGrid.getBoundingClientRect();
                    // 计算距离窗口底部的高度，留出20px边距
                    const maxHeight = windowHeight - gridRect.top - 20;
                    // 设置最小高度为200px
                    this.coursesCardHeight = Math.max(maxHeight, 200);
                }
            });
        },
        // 处理分类类型切换
        handleAccTypeChange(accType) {
            this.activeAccType = accType;
            // 重置分页和AI选课标志
            this.pagination.currentPage = 1;
            this.pagination.total = 0;
            this.isAiSearch = false;
            if (accType === null) {
                // 点击"全部"时隐藏分类容器，显示三级分类
                this.isCategoryContainerVisible = false;
                this.activeLevel1Id = null;
                this.activeLevel2Id = null;
                this.activeLevel3Id = null;
                this.currentCategoryLevel = 1;
                // 加载课程列表（带关键词搜索条件）
                this.getCoursList(null);
            } else {
                // 点击精选课程/移动集采/行业课程时显示分类容器
                this.isCategoryContainerVisible = true;
                this.currentCategoryLevel = 1;
                this.activeLevel1Id = null;
                this.activeLevel2Id = null;
                this.activeLevel3Id = null;
                // 加载对应类型的一级分类
                this.loadLevel1ByAccType(accType);
            }
        },
        // 根据accType加载一级分类
        async loadLevel1ByAccType(accType) {
            try {
                const res = await getAjCourseClassList({ accParentId: 0, accType: accType });
                this.courseData.level1Categories = res.data || [];
                this.courseData.level1Categories.forEach((item) => {
                    item.level2 = [];
                    item.loading = false;
                    item.loaded = false;
                });
                // 清空二级和三级分类
                this.courseData.level2Categories = [];
                this.courseData.level3Categories = [];
                this.activeLevel1Id = null;
                this.activeLevel2Id = null;
                this.activeLevel3Id = null;
                // 加载所有该类型的课程
                this.getCoursListByAccType(accType, null);
            } catch (error) {
                console.error('加载分类失败:', error);
                this.$message.error('加载分类失败，请重试');
            }
        },
        // 处理一级分类切换
        async handleLevel1Change(level1Id) {
            this.activeLevel1Id = level1Id;
            this.activeLevel2Id = null;
            this.activeLevel3Id = null;
            // 清空二级和三级分类，重置AI选课标志
            this.courseData.level2Categories = [];
            this.courseData.level3Categories = [];
            this.isAiSearch = false;
            if (level1Id === null) {
                // 点击"全部"时加载所有一级分类的课程
                this.getCoursListByAccType(this.activeAccType, null);
            } else {
                // 加载二级分类
                this.currentCategoryLevel = 2;
                await this.loadLevel2ByLevel1Id(level1Id);
            }
        },
        // 根据一级分类加载二级分类
        async loadLevel2ByLevel1Id(level1Id) {
            try {
                const level2Data = await getAjCourseClassList({ accParentId: level1Id });
                this.courseData.level2Categories = level2Data.data || [];
                // 默认选中"全部"，让用户手动选择
                this.activeLevel2Id = null;
                // 加载一级分类的课程
                this.getCoursListByAccType(this.activeAccType, level1Id);
            } catch (error) {
                console.error('加载二级分类失败:', error);
            }
        },
        // 处理二级分类切换
        async handleLevel2Change(level2Id) {
            this.activeLevel2Id = level2Id;
            this.activeLevel3Id = null;
            // 清空三级分类，重置AI选课标志
            this.courseData.level3Categories = [];
            this.isAiSearch = false;
            if (level2Id === null) {
                // 点击"全部"时加载一级分类的课程
                this.getCoursListByAccType(this.activeAccType, this.activeLevel1Id);
            } else {
                // 加载三级分类
                this.currentCategoryLevel = 3;
                await this.loadLevel3ByLevel2Id(level2Id);
            }
        },
        // 根据二级分类加载三级分类
        async loadLevel3ByLevel2Id(level2Id) {
            try {
                const level3Data = await getAjCourseClassListChild({ accId: level2Id });
                this.courseData.level3Categories = level3Data.data || [];
                // 默认选中"全部"，让用户手动选择
                this.activeLevel3Id = null;
                // 加载二级分类的课程
                this.getCoursListByAccType(this.activeAccType, level2Id);
            } catch (error) {
                console.error('加载三级分类失败:', error);
            }
        },
        // 根据accType和分类ID获取课程列表
        async getCoursListByAccType(accType, accId) {
            try {
                this.$loading.show();
                const params = {};
                // 添加关键词搜索条件
                if (this.keywordSearch && this.keywordSearch.trim()) {
                    params.courseTitle = this.keywordSearch.trim();
                }
                if (accType !== null) {
                    params.accType = accType;
                }
                if (accId !== null) {
                    params.accId = accId * 1;
                }
                const res = await getAjCourseList({
                    ...params,
                    pageSize: this.pagination.pageSize,
                    currentPage: this.pagination.currentPage,
                    courseNumClickSort: this.pagination.courseNumClickSort,
                });
                this.pagination.total = res.total || 0;
                this.$loading.close();
                this.$set(this.courseData, "courses", res.data || []);
            } catch (error) {
                console.error("加载课程列表失败:", error);
                this.$message.error("课程加载失败，请重试");
                this.courseData.courses = [];
                this.pagination.total = 0;
                this.$loading.close();
            }
        },
        viewCourseMine(course) {
            // 调用接口获取课程大纲详情
            this.$loading.show();
            getAjCourseOutlineDetails({ acoId: course.acoId }).then(res => {
                this.$loading.close();
                if (res.status == 200 && res.data) {
                    this.DiaLogDetailType = 2;
                    const data = JSON.parse(JSON.stringify(res.data))
                    data.ajCourseOutlineList = [res.data];
                    this.myDetailData = data
                    this.isDetailVisible = true;
                    this.$refs.courseDetailDialog.open();
                }
            }).catch(() => {
                this.$loading.close();
            });
        },
        getDetailData({ data, index }) {
            console.log(data);
            this.getDetailData_data = data;
            this.getDetailData_index = index;
            // 检查当前版本是否已被选用
            this.$nextTick(() => {
                this.checkVersionSelected();
            });
        },
        resetAiSelection() {
            this.aiInputText = '';
            this.aiAnalysisData = null;
            this.aiLoading = false;
            this.isAiHelperOpen = false;
            this.isAiSearch = false; // 重置AI选课标志
            this.pagination.currentPage = 1;
            this.getCoursList(this.activeLevel3Id);
            this.$message.success('已重置');
        },
        // 预加载模板库
        async loadTemplates() {
            try {
                await loadLocalTemplateLibrary('/templates');
            } catch (error) {
                console.warn('模板库预加载失败:', error.message);
            }
        },
        // 下载文档（使用预加载的模板库）
        async downloadDoc(courseData, versionData) {
            try {
                const templateLibrary = getPreloadedTemplateLibrary();
                if (!templateLibrary || Object.keys(templateLibrary).length === 0) {
                    this.$message.error('模板库未加载，请刷新页面重试');
                    return;
                }

                // 如果没有 versionData，直接使用 courseData
                const dataToExport = versionData ? { ...courseData, ...versionData } : courseData;

                // 根据预期成果数量选择模板
                const benefitsCount = parseBenefits(dataToExport.courseExpectedOutcome || dataToExport.benefits || '').length;
                console.log('导出使用：预期成果数量=' + benefitsCount + '，选择模板' + benefitsCount + '个');
                const template = selectTemplateByHighlights(benefitsCount, templateLibrary);

                if (!template) {
                    this.$message.error('未找到合适的模板');
                    return;
                }

                // 使用 exportCourseWord 导出
                await exportCourseWord([dataToExport], { template });
                updateAjCourseDownloadNumAddOne({ acoIds: JSON.stringify([courseData.acoId]) })
                this.$message.success('文档导出成功');
            } catch (error) {
                console.error('导出失败:', error);
                this.$message.error('导出失败：' + error.message);
            }
        },
        getTemporary() {
            getAjCourseSelectedMine().then(res => {
                this.temporaryStorage = res.data.ajCourseSelectedSimpleList
            })
            getAjCourseSelectedCustomizeMine().then(res => {
                this.aiOptimizeStorage = res.data
            })
        },
        tabValueChange(val) {
            this.storageTabActive = val;
            if (this.storageTabActive === 'course') {
                getAjCourseSelectedMine().then(res => {
                    this.temporaryStorage = res.data.ajCourseSelectedSimpleList
                })
            } else {
                getAjCourseSelectedCustomizeMine().then(res => {
                    this.aiOptimizeStorage = res.data
                })
            }
        },
        async handlePageChange(currentPage) {
            this.pagination.currentPage = currentPage;
            this.$loading.show();
            const params = {};
            // 添加关键词搜索条件
            if (this.keywordSearch && this.keywordSearch.trim()) {
                params.courseTitle = this.keywordSearch.trim();
            }
            // 根据当前选中的分类层级传入对应的accId
            if (this.activeLevel3Id) {
                params.accId = this.activeLevel3Id;
            } else if (this.activeLevel2Id) {
                params.accId = this.activeLevel2Id;
            } else if (this.activeLevel1Id) {
                params.accId = this.activeLevel1Id;
            }
            if (this.activeAccType !== null) {
                params.accType = this.activeAccType;
            }
            const res = await getAjCourseList({
                ...params,
                pageSize: this.pagination.pageSize,
                currentPage: this.pagination.currentPage,
                courseNumClickSort: this.pagination.courseNumClickSort,
            });
            this.pagination.total = res.total || 0;
            this.$set(this.courseData, "courses", res.data || []);
            this.$loading.close();
        },
        viewCourse(course) {
            this.DiaLogDetailType = 1;
            this.myDetailData = {};
            this.currentCourseId = course.courseId;
            this.isDetailVisible = true;
            this.$refs.courseDetailDialog.open();
            console.log(this.currentCourseId);
        },
        // 检查详情弹框中的当前版本是否已被选用
        checkVersionSelected() {
            const detailDialog = this.$refs.courseDetailDialog;
            if (detailDialog && detailDialog.currentVersionData) {
                const currentAcoId = detailDialog.currentVersionData.acoId;
                this.currentVersionSelected = this.temporaryStorage.some(
                    item => item.acoId === currentAcoId
                );
            }
        },
        // 处理选用课程事件
        handleSelectCourse() {
            // 通过 ref 获取详情弹框的数据
            const detailDialog = this.$refs.courseDetailDialog;
            const courseData = detailDialog.detailData;
            console.log('当前详情弹框数据:', courseData);
            console.log('当前版本索引:', detailDialog.currentVersionIndex);
            console.log('当前版本数据:', detailDialog.currentVersionData);

            const currentVersionData = detailDialog.currentVersionData;
            if (!currentVersionData) {
                this.$message.warning('无法获取课程版本信息');
                return;
            }
            // 检查是否已存在于暂存区
            const exists = this.temporaryStorage.some(
                (item) => item.acoId === currentVersionData.acoId
            );
            if (exists) {
                this.$message.warning("该课程已在暂存区中");
                return;
            }

            this.temporaryStorage.push(currentVersionData);
            updateAjCourseSelectedAdd({ acoId: currentVersionData.acoId }).then(res => {
                this.$message.success(`已选用课程：${currentVersionData.courseTitle + '-' + currentVersionData.teacherOutlineNames}，已加入暂存区`);
                this.isDetailVisible = false;
                this.checkVersionSelected()
            });
        },
        // 处理下载Word事件 - 子组件已内置处理，此方法保留用于兼容
        handleDownloadDoc() {
            // 子组件 CourseDetailDialog 内置了下载逻辑，无需父组件处理
        },
        // 处理AI优化事件
        handleAiOptimize() {
            // 从 courseDetailDialog 获取数据
            const detailDialog = this.$refs.courseDetailDialog;
            const courseData = detailDialog.detailData;
            const versionIndex = detailDialog.currentVersionIndex;

            if (!courseData) {
                this.$message.warning('无法获取课程详情');
                return;
            }

            // 重置为模式1（暂存区AI优化）
            this.AiDiaLogDetailType = 1;
            this.AiDiaLogShow = false;
            this.AiShowDetailData = {};

            this.currentCourseData = courseData;
            this.currentVersionIndex = versionIndex || 0;
            this.currentAcoId = courseData.ajCourseOutlineList?.[this.currentVersionIndex]?.acoId || '';
            this.$refs.aiOptimizeDialog.open();
        },
        // AI优化编辑（模式2：查看对比时的编辑功能）
        async handleAiEditTemplate() {
            const dialog = this.$refs.aiOptimizeDialog;
            console.log(dialog);
            const aiRefineData = dialog.aiRefineData;
            const detailData = dialog.detailData || {};
            const versionData = dialog.currentVersionData || {};
            console.log(detailData);

            // courseStyle 字段存储的是课程时长，需要赋值给 courseDays 供导出模板使用
            const courseStyleValue = detailData.courseStyle || versionData?.courseStyle || '';
            // 优先从detailData顶层获取基础字段，如果没有则从versionData获取
            const saveData = {
                acoId: dialog.acoId,
                acsuName: detailData.acsuName || versionData.acsuName || '',
                courseTitle: detailData.courseTitle || versionData.courseTitle || '',
                courseStyleDes: detailData.courseStyleDes || versionData.courseStyleDes || '',
                courseStyle: courseStyleValue,
                courseDays: courseStyleValue, // courseDays 映射到 courseDuration 用于导出
                courseOutline: dialog.formatOutlineToText(aiRefineData.courseOutline),
                courseIntroduce: aiRefineData.courseIntroduce || '',
                courseTarget: Array.isArray(aiRefineData.courseTarget)
                    ? aiRefineData.courseTarget.join('\n')
                    : (aiRefineData.courseTarget || ''),
                courseSpecialty: Array.isArray(aiRefineData.courseSpecialty)
                    ? aiRefineData.courseSpecialty.join('\n')
                    : (aiRefineData.courseSpecialty || ''),
                courseExpectedOutcome: Array.isArray(aiRefineData.courseExpectedOutcome)
                    ? aiRefineData.courseExpectedOutcome.join('\n')
                    : (aiRefineData.courseExpectedOutcome || ''),
                customerReview: JSON.stringify(aiRefineData.customerReview || {})
            };

            try {
                const res = await updateAjCourseSelectedCustomizeText({
                    acscId: this.TheacoId,
                    acscText: JSON.stringify(aiRefineData),
                    acscTextTwo: JSON.stringify(saveData)
                });
                if (res.status === 200) {
                    // 添加到AI优化暂存区
                    this.isAiOptimizeVisible = false;
                    this.$message.success('编辑成功');
                    this.tabValueChange('ai')
                } else {
                    this.$message.error('保存失败');
                }
            } catch (error) {
                console.error('保存AI优化失败:', error);
                this.$message.error('保存失败：' + error.message);
            }

        },
        // AI优化保存（导出Word功能）
        async handleAiSaveOptimized(saveData, aiRefineData) {
            console.log('导出AI优化数据:', saveData);
            await this.downloadDoc(saveData);
        },
        // 模式1：选用（保存到AI优化暂存区）
        async handleAiSelectCourse() {
            const dialog = this.$refs.aiOptimizeDialog;
            if (!dialog || !dialog.aiRefineData) {
                this.$message.warning('请先进行AI优化');
                return;
            }
            const aiRefineData = dialog.aiRefineData;
            const detailData = dialog.detailData || {};
            const currentVersionData = dialog.currentVersionData || {};
            // courseStyle 字段存储的是课程时长，需要赋值给 courseDays 供导出模板使用
            const courseStyleValue = detailData.courseStyle || currentVersionData?.courseStyle || '';
            const saveData = {
                acoId: dialog.acoId,
                acsuName: detailData.acsuName || currentVersionData.acsuName || '',
                courseTitle: detailData.courseTitle || currentVersionData.courseTitle || '',
                courseStyleDes: detailData.courseStyleDes || currentVersionData.courseStyleDes || '',
                courseStyle: courseStyleValue,
                courseDays: courseStyleValue, // courseDays 映射到 courseDuration 用于导出
                courseOutline: dialog.formatOutlineToText(aiRefineData.courseOutline),
                courseIntroduce: aiRefineData.courseIntroduce || '',
                courseTarget: Array.isArray(aiRefineData.courseTarget)
                    ? aiRefineData.courseTarget.join('\n')
                    : (aiRefineData.courseTarget || ''),
                courseSpecialty: Array.isArray(aiRefineData.courseSpecialty)
                    ? aiRefineData.courseSpecialty.join('\n')
                    : (aiRefineData.courseSpecialty || ''),
                courseExpectedOutcome: Array.isArray(aiRefineData.courseExpectedOutcome)
                    ? aiRefineData.courseExpectedOutcome.join('\n')
                    : (aiRefineData.courseExpectedOutcome || ''),
                customerReview: JSON.stringify(aiRefineData.customerReview || {})
            };

            try {
                const res = await updateAjCourseSelectedCustomizeAdd({
                    acoId: dialog.acoId,
                    acscText: JSON.stringify(aiRefineData),
                    acscTextTwo: JSON.stringify(saveData)
                });
                if (res.status === 200) {
                    // 添加到AI优化暂存区
                    this.aiOptimizeStorage.push(res.data);
                    console.log(this.aiOptimizeStorage);
                    this.aiOptimizeStorageCount++;
                    this.$message.success('AI优化已保存到暂存区');
                    this.isAiOptimizeVisible = false;
                    this.tabValueChange('ai')
                } else {
                    this.$message.error('保存失败');
                }
            } catch (error) {
                console.error('保存AI优化失败:', error);
                this.$message.error('保存失败：' + error.message);
            }
        },
        // 生成大纲逻辑图 - 调用子组件的逻辑图生成方法
        handleGenerateDiagram() {
            const detailDialog = this.$refs.courseDetailDialog;
            if (detailDialog && detailDialog.handleAiLogIc) {
                detailDialog.handleAiLogIc();
            } else {
                this.$message.error('无法打开大纲逻辑图');
            }
        },
        selectCourse(course) {
            // 检查是否已存在于暂存区
            const exists = this.temporaryStorage.some(
                (item) => item.courseId === course.courseId
            );
            if (exists) {
                this.$message.warning("该课程已在暂存区中");
                return;
            }
            // 添加到暂存区
            this.temporaryStorage.push(course);
            updateAjCourseSelectedAdd({ courseId: course.courseId }).then(res => {
                this.$message.success(`已选用课程：${course.courseTitle}，已加入暂存区`);
            })

        },
        // 从暂存区移除课程（新增）
        removeFromStorage(course) {
            const index = this.temporaryStorage.findIndex(
                (item) => item.acoId === course.acoId
            );
            if (index > -1) {
                updateAjCourseSelectedRemove({ acoId: course.acoId }).then(res => {
                    if (res.status == 200) {
                        this.temporaryStorage.splice(index, 1);
                        // 清除选中状态
                        this.temporaryStorageSelected = this.temporaryStorageSelected.filter(id => id !== course.acoId);
                        this.$message.success(`已从暂存区移除：${course.courseTitle + '-' + course.teacherOutlineNames}`);
                    }
                })
            }
        },

        // 导出暂存区Word
        async exportStorageWord(type) {
            try {
                // 防止重复点击
                if (this.isExportingWord) return;
                this.isExportingWord = true;

                // 获取选中的ID
                let ids = [];
                let exportDataList = [];
                if (type === 'course') {
                    ids = this.temporaryStorageSelected;
                    if (ids.length === 0) {
                        this.$message.warning('请先选择要导出的课程');
                        this.isExportingWord = false;
                        return;
                    }
                    // 调用接口获取多个大纲详情
                    const res = await getAjCourseOutlineDetailsByIds({ acoIds: JSON.stringify(ids) });
                    if (res.status !== 200 || !res.data || res.data.length === 0) {
                        this.$message.error('获取课程详情失败');
                        this.isExportingWord = false;
                        return;
                    }
                    exportDataList = res.data;
                } else if (type === 'ai') {
                    // AI优化暂存区
                    if (this.aiOptimizeStorageSelected.length === 0) {
                        this.$message.warning('请先选择要导出的课程');
                        this.isExportingWord = false;
                        return;
                    }
                    // 从aiOptimizeStorage中筛选选中的项
                    exportDataList = this.aiOptimizeStorage
                        .filter(item => this.aiOptimizeStorageSelected.includes(item.acscId))
                        .map(item => {
                            const saveData = JSON.parse(item.acscTextTwo || '{}');
                            // 设置courseTitle用于模板渲染
                            saveData.courseTitle = JSON.parse(item.acscTextTwo || '{}').courseTitle || '';
                            return saveData;
                        });
                }

                if (exportDataList.length === 0) {
                    this.$message.warning('没有可导出的数据');
                    this.isExportingWord = false;
                    return;
                }

                // 加载模板库
                const templateLibrary = getPreloadedTemplateLibrary();
                if (!templateLibrary || Object.keys(templateLibrary).length === 0) {
                    await loadLocalTemplateLibrary('/templates');
                }
                const templateLibraryNow = getPreloadedTemplateLibrary();
                if (!templateLibraryNow || Object.keys(templateLibraryNow).length === 0) {
                    this.$message.error('未找到可用的模板');
                    this.isExportingWord = false;
                    return;
                }

                // 为每个课程单独选择模板并生成文档
                const results = [];
                for (let i = 0; i < exportDataList.length; i++) {
                    const courseData = exportDataList[i];
                    const benefitsCount = parseBenefits(courseData.courseExpectedOutcome || courseData.benefits || '').length;
                    console.log(`第${i + 1}个课程：预期成果=${benefitsCount}，选择模板${benefitsCount}个`);
                    const template = selectTemplateByHighlights(benefitsCount, templateLibraryNow);
                    if (!template) {
                        console.warn(`第${i + 1}个课程未找到合适的模板`);
                        continue;
                    }
                    const result = await generateCourseWord(courseData, template, { index: i });
                    results.push(result);
                }

                console.log('原始结果:', results);

                // 过滤成功的文档并打包下载
                const validResults = results.filter(r => r.success);
                console.log('成功数量:', validResults.length, '失败数量:', results.length - validResults.length);

                // 打印失败原因
                results.forEach((r, i) => {
                    if (!r.success) {
                        console.log(`第${i + 1}个失败:`, r.error || '未知错误');
                    }
                });

                if (validResults.length === 0) {
                    this.$message.error('导出失败，所有文档生成失败');
                    this.isExportingWord = false;
                    return;
                }

                // 单个直接下载，多个打包下载
                if (validResults.length === 1) {
                    downloadWord(validResults[0].blob, validResults[0].filename);
                } else {
                    await downloadBatchWord(validResults, `课程文档_${new Date().getTime()}.zip`);
                }

                this.$message.success(`成功导出 ${validResults.length} 个文档`);
                this.isExportingWord = false;
            } catch (error) {
                console.error('导出Word失败:', error);
                this.$message.error('导出Word失败：' + error.message);
                this.isExportingWord = false;
            }
        },
        // 移除选中的暂存区项目
        removeStorageSelected(type) {
            if (type === 'course') {
                const selected = this.temporaryStorage.filter(item =>
                    this.temporaryStorageSelected.includes(item.acoId)
                );
                if (selected.length === 0) return;

                this.$confirm(`确定要移除选中的 ${selected.length} 个课程吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const ids = selected.map(item => item.acoId);
                    // 批量移除
                    ids.forEach(acoId => {
                        const idx = this.temporaryStorage.findIndex(item => item.acoId === acoId);
                        if (idx > -1) {
                            updateAjCourseSelectedRemove({ acoId }).then(() => {
                                this.temporaryStorage.splice(idx, 1);
                            });
                        }
                    });
                    this.temporaryStorageSelected = [];
                    this.$message.success(`已移除 ${selected.length} 个课程`);
                }).catch(() => { });
            } else if (type === 'ai') {
                const selected = this.aiOptimizeStorage.filter(item =>
                    this.aiOptimizeStorageSelected.includes(item.id)
                );
                if (selected.length === 0) return;

                this.$confirm(`确定要移除选中的 ${selected.length} 个AI优化课程吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    selected.forEach(item => {
                        const idx = this.aiOptimizeStorage.findIndex(i => i.id === item.id);
                        if (idx > -1) {
                            this.aiOptimizeStorage.splice(idx, 1);
                        }
                    });
                    this.aiOptimizeStorageSelected = [];
                    this.$message.success(`已移除 ${selected.length} 个AI优化课程`);
                }).catch(() => { });
            }
        },
        // 查看AI优化暂存区课程（模式2：对比查看）
        async viewAiOptimize(item) {
            this.AiDiaLogDetailType = 2; // 设置为模式2
            this.AiDiaLogShow = true; // 显示对比模式
            const data = await getAjCourseOutlineDetails({ acoId: item.acoId }) || {};
            console.log(data);
            // 设置原版数据
            this.TheacoId = item.acscId
            this.AiShowDetailData = data.data
            // 设置当前课程数据用于显示AI优化版本
            this.currentCourseData = data.data
            this.currentVersionIndex = 0;
            this.currentAcoId = item.acoId;

            // 设置AI优化数据到弹窗
            this.$nextTick(() => {
                const dialog = this.$refs.aiOptimizeDialog;
                if (dialog && item.acscText) {
                    dialog.aiRefineData = { ...JSON.parse(item.acscText) };
                    dialog.optimizeKey = Date.now().toString();
                }
            });

            this.isAiOptimizeVisible = true;
            this.$refs.aiOptimizeDialog.open();
        },
        // 移除AI优化暂存区课程
        removeAiOptimize(item) {
            const index = this.aiOptimizeStorage.findIndex(i => i.acscId === item.acscId);
            if (index > -1) {
                updateAjCourseSelectedCustomizeRemove({ acscId: item.acscId }).then(res => {
                    if (res.status == 200) {
                        this.tabValueChange('ai');
                        this.$message.success('已从AI优化暂存区移除');
                    }
                });
            }
        },
        // 获取当前tab数据长度
        getCurrentStorageLength() {
            if (this.storageTabActive === 'course') {
                return this.temporaryStorage.length;
            } else {
                return this.aiOptimizeStorageCount > 0 ? this.aiOptimizeStorageCount : this.aiOptimizeStorage.length;
            }
        },
        // 获取选中数量
        getSelectedCount() {
            return this.storageTabActive === 'course' ? this.temporaryStorageSelected.length : this.aiOptimizeStorageSelected.length;
        },
        // 切换全选
        handleToggleSelectAll(val) {
            if (this.storageTabActive === 'course') {
                if (val) {
                    this.temporaryStorageSelected = this.temporaryStorage.map(item => item.acoId);
                } else {
                    this.temporaryStorageSelected = [];
                }
            } else {
                if (val) {
                    this.aiOptimizeStorageSelected = this.aiOptimizeStorage.map(item => item.id);
                } else {
                    this.aiOptimizeStorageSelected = [];
                }
            }
        },
        // 处理tab切换
        handleTabChange() {
            // 切换tab时不清除选中状态，保留用户选择
            return true;
        },
        // 导出Excel
        async exportStorageExcel(type) {
            try {
                if (type === 'course') {
                    const ids = this.temporaryStorageSelected;
                    if (ids.length === 0) {
                        this.$message.warning('请先选择要导出的课程');
                        return;
                    }
                    // 调用接口导出Excel
                    const params = qs.stringify({ acoIds: JSON.stringify(ids) });
                    await exportFile('/ajCourseOutline/exportAjCourseOutline', params, '课程大纲');
                    this.$message.success(`成功导出 ${ids.length} 条数据`);
                } else if (type === 'ai') {
                    // AI优化暂存区
                    const ids = this.aiOptimizeStorageSelected;
                    if (ids.length === 0) {
                        this.$message.warning('请先选择要导出的课程');
                        return;
                    }
                    // 调用接口导出Excel
                    const params = qs.stringify({ acscIds: JSON.stringify(ids) });
                    await exportFile('/ajCourseSelectedCustomize/exportAjCourseSelectedCustomize', params, 'AI优化课程');
                    this.$message.success(`成功导出 ${ids.length} 条数据`);
                }
            } catch (error) {
                console.error('导出Excel失败:', error);
                this.$message.error('导出Excel失败：' + (error.message || '未知错误'));
            }
        },
        handleSelect(index, indexPath) {
            console.log(index, indexPath);
            this.theMenuVale = index;
            if (indexPath.length > 1) {
                const level1Id = Number(indexPath[1]);
                const level1Item = this.courseData.level1Categories.find(
                    (item) => item.accId === level1Id
                );
                if (level1Item) {
                    this.updateBreadcrumb(["全部", level1Item.accName]);
                }
                this.getLv3(indexPath[indexPath.length - 1]);
            } else {
                this.updateBreadcrumb(["全部"]);
            }
        },
        // 排序处理：0-不排序 1-点击正序 2-点击倒序 3-下载正序 4-下载倒序 5-更新时间正序 6-更新时间倒序
        handleSort(positiveVal, negativeVal) {
            const currentSort = this.pagination.courseNumClickSort;
            if (currentSort === positiveVal) {
                this.pagination.courseNumClickSort = negativeVal;
            } else if (currentSort === negativeVal) {
                this.pagination.courseNumClickSort = positiveVal;
            } else {
                this.pagination.courseNumClickSort = positiveVal;
            }
            this.getCoursList(this.activeLevel3Id);
        },
        async getCoursList(id, accType = null) {
            try {
                this.$loading.show();
                // 根据当前选中的分类层级获取正确的accId
                let accId = id;
                if (!accId && this.activeLevel3Id) {
                    accId = this.activeLevel3Id;
                } else if (!accId && this.activeLevel2Id) {
                    accId = this.activeLevel2Id;
                } else if (!accId && this.activeLevel1Id) {
                    accId = this.activeLevel1Id;
                }
                const params = accId !== null ? { accId: accId * 1 } : {};
                // 添加关键词搜索条件
                if (this.keywordSearch && this.keywordSearch.trim()) {
                    params.courseTitle = this.keywordSearch.trim();
                }
                // 如果传入了accType参数，使用它；否则使用当前的activeAccType
                const typeToUse = accType !== null ? accType : this.activeAccType;
                if (typeToUse !== null) {
                    params.accType = typeToUse;
                }
                const res = await getAjCourseList({
                    ...params,
                    pageSize: this.pagination.pageSize,
                    currentPage: this.pagination.currentPage,
                    courseNumClickSort: this.pagination.courseNumClickSort
                });
                this.pagination.total = res.total || 0;
                this.$set(this.courseData, "courses", res.data || []);
                this.$loading.close();
            } catch (error) {
                console.error("加载课程列表失败:", error);
                this.$message.error("课程加载失败，请重试");
                this.courseData.courses = [];
                this.pagination.total = 0;
                this.$loading.close();
            }
        },
        async getLv3(id) {
            try {
                const level3Data = await getAjCourseClassListChild({ accId: id * 1 });
                this.$set(this.courseData, "level3Categories", level3Data.data || []);
                if (this.courseData.level3Categories.length > 0) {
                    this.activeLv3Defult = id * 1;
                    this.activeLevel3Id = id * 1;
                    this.getCoursList(this.activeLevel3Id);
                } else {
                    this.activeLv3Defult = id * 1;
                    this.activeLevel3Id = id * 1;
                    this.getCoursList(this.activeLevel3Id);
                }
            } catch (error) {
                console.error("加载三级分类失败:", error);
                this.$message.error("分类加载失败，请重试");
            }
        },
        handleLevel3Change(accId) {
            this.activeLevel3Id = accId;
            this.isAiSearch = false;
            this.getCoursList(accId);
        },
        toggleExpand() {
            this.isExpand = !this.isExpand;
        },
        // 切换分类区域折叠/展开
        toggleCategoryFold() {
            this.isCategoryFolded = !this.isCategoryFolded;
        },
        handleSubmenuOpen(index) {
            console.log(index);
            const level1Id = Number(index);
            const level1Item = this.courseData.level1Categories.find(
                (item) => item.accId === level1Id
            );
            if (level1Item.loaded || level1Item.loading) {
                return;
            }
            this.loadLevel2CategoriesByLevel1Id(level1Id);
        },
        async loadLevel2CategoriesByLevel1Id(level1Id) {
            try {
                const level1Index = this.courseData.level1Categories.findIndex(
                    (item) => item.accId === level1Id
                );
                if (level1Index === -1) return;
                this.$set(this.courseData.level1Categories[level1Index], "loading", true);
                const level2Data = await getAjCourseClassList({ accParentId: level1Id });
                this.$set(
                    this.courseData.level1Categories[level1Index],
                    "level2",
                    level2Data.data || []
                );
                this.$set(this.courseData.level1Categories[level1Index], "loaded", true);
                this.$set(this.courseData.level1Categories[level1Index], "loading", false);
                if (level2Data.data && level2Data.data.length > 0) {
                    this.getLv3(level1Id);
                }
            } catch (error) {
                console.error(`加载一级分类${level1Id}的二级分类失败:`, error);
                this.$message.error(`加载失败，请重试`);
                const level1Index = this.courseData.level1Categories.findIndex(
                    (item) => item.accId === level1Id
                );
                if (level1Index !== -1) {
                    this.$set(this.courseData.level1Categories[level1Index], "loading", false);
                }
            }
        },
        toggleAiHelper() {
            this.isAiHelperOpen = !this.isAiHelperOpen;
            if (this.isAiHelperOpen) {
                this.$nextTick(() => {
                    const input = this.$el.querySelector(".ai-input-field input");
                    if (input) input.focus();
                });
            } else {
                this.aiInputText = "";
                this.aiAnalysisData = null;
                this.isLoading = false;
            }
        },
        sendAiRequest() {
            if (!this.aiInputText.trim()) {
                this.$message.warning("请输入您的培训需求");
                return;
            }
            this.isLoading = true;
            this.aiAnalysisData = null;
            // 根据当前选中的分类层级获取正确的accId
            let accId = this.activeLevel3Id;
            if (!accId && this.activeLevel2Id) {
                accId = this.activeLevel2Id;
            } else if (!accId && this.activeLevel1Id) {
                accId = this.activeLevel1Id;
            }
            getAjCourseListAi({
                courseKeyWord: this.aiInputText,
                accId: accId,
                accType: this.activeAccType,
            })
                .then((res) => {
                    const data = res.data;
                    const aiCourseList = data.ajCourseListResult || [];
                    this.$set(this.courseData, "courses", aiCourseList);
                    // AI选课结果有多少展示多少，不分页
                    this.pagination.total = aiCourseList.length;
                    this.pagination.currentPage = 1;
                    this.isAiSearch = true; // 标记为AI选课结果
                    this.aiAnalysisData = {
                        matchReason: data.matchReason || "暂无匹配理由",
                        courseReasons: data.courseReasons || [],
                        keywords: data.keywords || [],
                    };
                    this.$message.success("AI分析完成");
                })
                .catch((err) => {
                    console.error("AI匹配失败:", err);
                    this.$message.error("AI分析失败，请重试");
                    this.aiAnalysisData = null;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        updateBreadcrumb(breadcrumb) {
            this.currentBreadCrumb = breadcrumb || [];
        },
        handleKeywordSearch() {
            const keyword = this.keywordSearch.trim();
            // 搜索时重置到第一页，并重置AI选课标志
            this.pagination.currentPage = 1;
            this.isAiSearch = false;
            if (!keyword) {
                this.getCoursList(this.activeLevel3Id);
                return;
            }
            this.$loading.show();
            console.log(this.pagination);
            const params = { courseTitle: keyword };
            // 根据当前选中的分类层级传入对应的accId
            if (this.activeLevel3Id) {
                params.accId = this.activeLevel3Id;
            } else if (this.activeLevel2Id) {
                params.accId = this.activeLevel2Id;
            } else if (this.activeLevel1Id) {
                params.accId = this.activeLevel1Id;
            }
            if (this.activeAccType !== null) {
                params.accType = this.activeAccType;
            }
            getAjCourseList({ ...params, pageSize: this.pagination.pageSize, currentPage: this.pagination.currentPage, courseNumClickSort: this.pagination.courseNumClickSort })
                .then((res) => {
                    this.$loading.close();
                    this.$set(this.courseData, "courses", res.data || []);
                    this.pagination.total = res.total || 0;
                    this.pagination.currentPage = 1;
                    this.$message.success(`找到 ${res.total || 0} 个相关课程`);
                })
                .catch((err) => {
                    console.error("关键词搜索失败:", err);
                    this.$message.error("搜索失败，请重试");
                    this.$loading.close();
                });
        },
    },
};
</script>
